(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[222],{

/***/ 4705:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_brixel.ch/team",
      function () {
        return __webpack_require__(5093);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1904:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2125);
/* harmony import */ var _Header__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4890);
/* harmony import */ var _Footer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2980);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: calc( 42px + ( 4 * var( --stack-basis ) ) ) auto 0 auto;\n  /* max-width: 2000px; */\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




function AppChrome(param) {
    var _navigationBar = param.navigationBar, navigationBar = _navigationBar === void 0 ? null : _navigationBar, _footerPageSegments = param.footerPageSegments, footerPageSegments = _footerPageSegments === void 0 ? null : _footerPageSegments, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Header__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                navigationBar: navigationBar
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledAppMain, {
                children: children
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Footer__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                pageSegments: footerPageSegments
            })
        ]
    });
}
var StyledAppMain = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-5dc7e6c0-0"
})(_templateObject());
/* harmony default export */ __webpack_exports__["Z"] = (AppChrome);


/***/ }),

/***/ 2980:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2125);
/* harmony import */ var _lib_craft__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8767);
/* harmony import */ var _pageSegments_PageSegments__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1135);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: 0 auto;\n  /* max-width: 2000px; */\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




function Footer(param) {
    var _pageSegments = param.pageSegments, pageSegments = _pageSegments === void 0 ? null : _pageSegments;
    var ref, ref1, ref2;
    var craftData = (0,_lib_craft__WEBPACK_IMPORTED_MODULE_2__/* .useCraft */ .Yi)();
    var segments = pageSegments || (craftData === null || craftData === void 0 ? void 0 : (ref = craftData.pageProps) === null || ref === void 0 ? void 0 : (ref1 = ref.footer) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.pageSegments);
    if (!segments) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledFooter, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pageSegments_PageSegments__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            pageSegments: segments
        })
    });
}
var StyledFooter = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-7e2154cb-0"
})(_templateObject());
/* harmony default export */ __webpack_exports__["Z"] = (Footer);


/***/ }),

/***/ 4890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Header; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(2125);
// EXTERNAL MODULE: ./lib/craft/index.tsx + 31 modules
var craft = __webpack_require__(8767);
// EXTERNAL MODULE: ./components/layout/Container.tsx
var Container = __webpack_require__(6797);
// EXTERNAL MODULE: ./components/layout/Stack.tsx
var Stack = __webpack_require__(4970);
// EXTERNAL MODULE: ./components/BrixelLogo.tsx
var BrixelLogo = __webpack_require__(2290);
// EXTERNAL MODULE: ./components/Link.tsx
var Link = __webpack_require__(5741);
// EXTERNAL MODULE: ./components/navigationBar/NavigationBar.tsx + 6 modules
var NavigationBar = __webpack_require__(8549);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(9815);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(4012);
;// CONCATENATED MODULE: ./components/icons/TelephoneIcon.tsx

function TelephoneIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "19",
        height: "18",
        viewBox: "0 0 19 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.34452 7.54331C6.47782 7.41006 6.58356 7.25186 6.65571 7.07775C6.72785 6.90363 6.76498 6.717 6.76498 6.52853C6.76498 6.34006 6.72785 6.15343 6.65571 5.97931C6.58356 5.80519 6.47782 5.64699 6.34452 5.51375L4.82218 3.99212C4.55311 3.72313 4.18822 3.57202 3.80776 3.57202C3.42729 3.57202 3.06241 3.72313 2.79334 3.99212L1.95827 4.82719C1.60831 5.17815 1.39021 5.63915 1.3408 6.13231C1.29139 6.62547 1.41371 7.12057 1.68709 7.53398C4.1442 11.2325 7.31495 14.4032 11.0134 16.8603C11.4269 17.1336 11.9221 17.2558 12.4152 17.2063C12.9084 17.1567 13.3694 16.9385 13.7202 16.5884L14.556 15.7534C14.825 15.4843 14.9761 15.1194 14.9761 14.7389C14.9761 14.3585 14.825 13.9936 14.556 13.7245L13.0337 12.2029C12.7646 11.9339 12.3997 11.7828 12.0193 11.7828C11.6388 11.7828 11.2739 11.9339 11.0048 12.2029L10.4976 12.7101C8.79588 11.3104 7.23415 9.74868 5.83444 8.04693L6.34452 7.54331Z",
                stroke: "#009877",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.5791 0.718506C11.7672 0.718506 13.8657 1.58772 15.4129 3.13494C16.9601 4.68216 17.8293 6.78064 17.8293 8.96874",
                stroke: "#009877",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.5791 3.58813C11.0061 3.58813 12.3747 4.15502 13.3838 5.16407C14.3928 6.17313 14.9597 7.5417 14.9597 8.96872",
                stroke: "#009877",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.5791 6.45776C10.245 6.45776 10.8837 6.72231 11.3546 7.1932C11.8255 7.66409 12.09 8.30276 12.09 8.96871",
                stroke: "#009877",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/OpenClosed.tsx


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin-top: 4px;\n  color: ",
        ";\n  font-size: ",
        ";\n\n  > span {\n    @media ( max-width: 600px ) {\n      display: none;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-weight: 600;\n  font-size: inherit;\n  color: inherit;\n  text-decoration-color: transparent;\n  text-decoration-thickness: 1px;\n  text-underline-offset: 2px;\n  transition: text-decoration-color .3s ease-out;\n  &:hover {\n    text-decoration-color: inherit;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  border-radius: 20rem;\n  background-color: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}







function OpenClosed() {
    var ref, ref1;
    var ref2 = (0,router.useRouter)(), locale = ref2.locale, defaultLocale = ref2.defaultLocale;
    var craftData = (0,craft/* useCraft */.Yi)();
    var ref3 = (0,react.useState)(null), isOpen = ref3[0], setIsOpen = ref3[1];
    var ref4 = (0,react.useState)(null), nextOpen = ref4[0], setNextOpen = ref4[1];
    var serializedOpeningTimes = JSON.stringify(craftData === null || craftData === void 0 ? void 0 : (ref = craftData.pageProps) === null || ref === void 0 ? void 0 : (ref1 = ref.businessHours) === null || ref1 === void 0 ? void 0 : ref1.openingTimes);
    var openingTimes = (0,react.useMemo)(function() {
        var ref, ref1;
        return (craftData === null || craftData === void 0 ? void 0 : (ref = craftData.pageProps) === null || ref === void 0 ? void 0 : (ref1 = ref.businessHours) === null || ref1 === void 0 ? void 0 : ref1.openingTimes) || [];
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        serializedOpeningTimes
    ]);
    var weekdayFormatter = new Intl.DateTimeFormat([
        locale || defaultLocale || "en_US"
    ], {
        weekday: "long"
    });
    var timeFormatter = new Intl.DateTimeFormat([
        locale || defaultLocale || "en_US"
    ], {
        timeStyle: "short"
    });
    (0,react.useEffect)(function() {
        var timer = null;
        if (timer) {
            clearInterval(timer);
        }
        timer = setInterval(function() {
            // check if open
            setIsOpen(areWeOpen(openingTimes));
            setNextOpen(whenAreWeNextOpen(openingTimes));
        }, 1000 * 60);
        setIsOpen(areWeOpen(openingTimes));
        setNextOpen(whenAreWeNextOpen(openingTimes));
    }, [
        openingTimes
    ]);
    if (isOpen === null) {
        return null;
    }
    if (isOpen) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledOpenClosed, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                        description: "[Brixel] is open",
                        defaultMessage: "is open",
                        id: "FthgtD"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CallUs, {})
            ]
        });
    }
    if (nextOpen && nextOpen.getDate() !== new Date().getDate()) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledOpenClosed, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                    description: "opens on [Monday/Tuesday/etc…]",
                    defaultMessage: "opens on ",
                    id: "RlDzFA"
                }),
                " ",
                weekdayFormatter.format(nextOpen)
            ]
        });
    }
    if (nextOpen) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledOpenClosed, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                    description: "opens at [9am]",
                    defaultMessage: "opens at ",
                    id: "HS4fmx"
                }),
                " ",
                timeFormatter.format(nextOpen)
            ]
        });
    }
    return null;
}
function CallUs() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCallUs, {
        href: "tel:+41 44 552 57 30",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPhoneIcon, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TelephoneIcon, {})
            }),
            "+41 44 552 57 30"
        ]
    });
}
var StyledOpenClosed = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ef933484-0"
})(_templateObject(), function(p) {
    return p.theme.colors.green400;
}, function(p) {
    return p.theme.typo.sizes.dropped;
});
var StyledCallUs = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-ef933484-1"
})(_templateObject1());
var StyledPhoneIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ef933484-2"
})(_templateObject2(), function(p) {
    return p.theme.colors.green100;
});
function areWeOpen(openingTimes) {
    var now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new Date();
    var today = now.getDay();
    var todaysOpeningTimes = openingTimes.filter(function(ot) {
        return ot.day === daysOfTheWeek[today];
    });
    var timeSlots = todaysOpeningTimesToSlots(now, todaysOpeningTimes);
    for(var i = 0, len = timeSlots.length; i < len; i += 1){
        var slot = timeSlots[i];
        if (now >= slot.opens && now <= slot.closes) {
            return true;
        }
    }
    return false;
}
function whenAreWeNextOpen(openingTimes) {
    var now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new Date();
    var nextOpenToday = whenAreWeNextOpenOnDay(now, openingTimes);
    if (nextOpenToday) {
        return nextOpenToday;
    }
    for(var i = 0, len = daysOfTheWeek.length; i < len; i += 1){
        var thisDay = new Date(now);
        thisDay.setUTCHours(0);
        thisDay.setUTCMinutes(0);
        thisDay.setUTCSeconds(0);
        thisDay.setDate(thisDay.getDate() + i);
        var nextOpenThisDay = whenAreWeNextOpenOnDay(thisDay, openingTimes);
        if (nextOpenThisDay) {
            return nextOpenThisDay;
        }
    }
    return false;
}
function whenAreWeNextOpenOnDay(day, openingTimes) {
    var today = day.getDay();
    var todaysOpeningTimes = openingTimes.filter(function(ot) {
        return ot.day === daysOfTheWeek[today];
    });
    var timeSlots = todaysOpeningTimesToSlots(day, todaysOpeningTimes);
    for(var i = 0, len = timeSlots.length; i < len; i += 1){
        var slot = timeSlots[i];
        if (day < slot.opens) {
            return slot.opens;
        }
    }
    return false;
}
function todaysOpeningTimesToSlots(now, openingTimes) {
    return openingTimes.reduce(function(slots, ot, currentIndex) {
        var ref;
        if (currentIndex % 2) {
            return slots;
        }
        var openingTime = new Date(ot.time);
        var closingTime = new Date(((ref = openingTimes[currentIndex + 1]) === null || ref === void 0 ? void 0 : ref.time) || null);
        openingTime.setFullYear(now.getFullYear());
        openingTime.setMonth(now.getMonth());
        openingTime.setDate(now.getDate());
        closingTime.setFullYear(now.getFullYear());
        closingTime.setMonth(now.getMonth());
        closingTime.setDate(now.getDate());
        return (0,_to_consumable_array/* default */.Z)(slots).concat([
            {
                opens: openingTime,
                closes: closingTime
            }, 
        ]);
    }, []);
}
var daysOfTheWeek = [
    "sunday",
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday", 
];

;// CONCATENATED MODULE: ./components/Header.tsx

function Header_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  z-index: 1;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  background: ",
        ";\n"
    ]);
    Header_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Header_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n\n  > * {\n    margin-right: 1rem;\n  }\n\n  > * + *:last-child {\n    margin-left: auto;\n    margin-right: 0;\n  }\n\n  svg {\n    display: block;\n  }\n"
    ]);
    Header_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}









function Header(param) {
    var _logoLink = param.logoLink, logoLink = _logoLink === void 0 ? "/" : _logoLink, _navigationBar = param.navigationBar, navigationBar = _navigationBar === void 0 ? null : _navigationBar, _openClosed = param.openClosed, openClosed = _openClosed === void 0 ? null : _openClosed, _children = param.children, children = _children === void 0 ? null : _children;
    var ref, ref1, ref2, ref3, ref4;
    var craftData = (0,craft/* useCraft */.Yi)();
    var navBar = navigationBar || (craftData === null || craftData === void 0 ? void 0 : (ref = craftData.pageProps) === null || ref === void 0 ? void 0 : (ref1 = ref.header) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.navigationBar);
    var showOpenClosed = openClosed === null ? craftData === null || craftData === void 0 ? void 0 : (ref3 = craftData.pageProps) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.businessHours) === null || ref4 === void 0 ? void 0 : ref4.openSign : openClosed;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeader, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            $containerType: "small-margin",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.ZP, {
                $top: 2,
                $bottom: 2,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeaderInner, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                            href: logoLink,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BrixelLogo/* default */.Z, {
                                breakpoint: 500
                            })
                        }),
                        showOpenClosed && /*#__PURE__*/ (0,jsx_runtime.jsx)(OpenClosed, {}),
                        !!(navBar === null || navBar === void 0 ? void 0 : navBar.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationBar/* default */.Z, {
                            navigationBar: navBar
                        }),
                        children
                    ]
                })
            })
        })
    });
}
var StyledHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-61651a6-0"
})(Header_templateObject(), function(p) {
    return p.theme.colors.realWhite;
});
var StyledHeaderInner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-61651a6-1"
})(Header_templateObject1());
/* harmony default export */ var components_Header = (Header);


/***/ }),

/***/ 5093:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ team; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./components/AppChrome.tsx
var AppChrome = __webpack_require__(1904);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(2125);
// EXTERNAL MODULE: ./components/Image.tsx
var Image = __webpack_require__(7753);
;// CONCATENATED MODULE: ./components/heroes/HeroImageOnly.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  height: min( 65vw, calc( 100vh - 72px ) );\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



function HeroImageOnly(param) {
    var image = param.image;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeroImageOnly, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.ZP, {
            src: image.url,
            alt: image.alt,
            dateModified: image.dateModified,
            layout: "fill",
            objectFit: "cover"
        })
    });
}
var StyledHeroImageOnly = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4e017730-0"
})(_templateObject());

// EXTERNAL MODULE: ./components/layout/Container.tsx
var Container = __webpack_require__(6797);
// EXTERNAL MODULE: ./components/layout/Stack.tsx
var Stack = __webpack_require__(4970);
// EXTERNAL MODULE: ./components/pageSegments/PageSegmentBackground.tsx
var PageSegmentBackground = __webpack_require__(2475);
// EXTERNAL MODULE: ./components/pageSegments/PageSegmentHeading.tsx
var PageSegmentHeading = __webpack_require__(157);
;// CONCATENATED MODULE: ./components/icons/contact/LinkedIn.tsx

function LinkedInIcon(param) {
    var _title = param.title, title = _title === void 0 ? null : _title;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        viewBox: "0 0 24 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: title || "LinkedIn"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.66977 21.63H0.809767V7.7H5.66977V21.63ZM15.7598 12.24C15.1922 12.24 14.6479 12.4655 14.2466 12.8668C13.8452 13.2681 13.6198 13.8124 13.6198 14.38V21.63H8.50977V7.7H13.6198V9.29C14.8175 8.27606 16.3306 7.71039 17.8998 7.69C21.0698 7.69 23.2698 10.04 23.2698 14.5V21.63H17.8998V14.38C17.9011 14.0981 17.8467 13.8188 17.7397 13.558C17.6328 13.2972 17.4754 13.0601 17.2765 12.8603C17.0777 12.6606 16.8413 12.502 16.581 12.3939C16.3207 12.2857 16.0416 12.23 15.7598 12.23V12.24ZM5.75977 2.88C5.75977 3.37446 5.61314 3.85781 5.33844 4.26893C5.06374 4.68005 4.67329 5.00048 4.21648 5.1897C3.75966 5.37892 3.25699 5.42843 2.77204 5.33197C2.28709 5.2355 1.84163 4.9974 1.492 4.64777C1.14237 4.29814 0.904267 3.85268 0.807804 3.36773C0.71134 2.88278 0.760849 2.38011 0.950068 1.9233C1.13929 1.46648 1.45972 1.07603 1.87084 0.801331C2.28196 0.526627 2.76531 0.380005 3.25977 0.380005C3.91934 0.385282 4.55009 0.651001 5.01462 1.11927C5.47914 1.58754 5.73979 2.22041 5.73977 2.88H5.75977Z",
                fill: "#D9D9D9"
            })
        ]
    });
}
/* harmony default export */ var LinkedIn = (LinkedInIcon);

;// CONCATENATED MODULE: ./components/people/Person.tsx

function Person_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n\n  p {\n    &:first-child {\n      margin-top: 0;\n    }\n    \n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n"
    ]);
    Person_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  aspect-ratio: 258 / 280;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  a {\n    display: block;\n    height: 24px;\n\n    svg {\n      height: 100%;\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}





function Person(param) {
    var person = param.person;
    var img = person.profileImage[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPerson, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.ZP, {
            $between: 1,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* StackItem */.vO, {
                    $bottom: 4,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPersonImage, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.ZP, {
                            src: img.url,
                            alt: person.title,
                            dateModified: img.dateModified,
                            layout: "fill",
                            objectFit: "cover"
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    children: person.title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* StackItem */.vO, {
                    $bottom: 2,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML: {
                            __html: person.bodyText
                        }
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledContactLinks, {
                    children: person.contactLinks.map(function(contactLink) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: contactLink.linkUrl,
                            target: "_blank",
                            rel: "noreferrer",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactLinkIcon, {
                                iconType: contactLink.icon
                            })
                        }, contactLink.id);
                    })
                })
            ]
        })
    });
}
function ContactLinkIcon(param) {
    var iconType = param.iconType;
    switch(iconType){
        case "linkedin":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkedIn, {});
        default:
            return null;
    }
}
var StyledPerson = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fb772d04-0"
})(Person_templateObject());
var StyledPersonImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fb772d04-1"
})(_templateObject1());
var StyledContactLinks = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fb772d04-2"
})(_templateObject2());

;// CONCATENATED MODULE: ./components/people/People.tsx

function People_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  --gap: calc( 2 * var( --grid-gutter ) );\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: var( --gap );\n\n  @media ( min-width: 540px ) {\n    grid-template-columns: repeat( 2, 1fr );\n  }\n  \n  @media ( min-width: 750px ) {\n    grid-template-columns: repeat( 3, 1fr );\n  }\n  \n  @media ( min-width: 1100px ) {\n    grid-template-columns: repeat( 4, 1fr );\n  }\n"
    ]);
    People_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



function People(param) {
    var people = param.people;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPeopleGrid, {
        children: people.map(function(person) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Person, {
                person: person
            }, person.id);
        })
    });
}
var StyledPeopleGrid = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e0f291a1-0"
})(People_templateObject());

;// CONCATENATED MODULE: ./pages/_brixel.ch/team.tsx








function BrixelTeamPage(param) {
    var teamPage = param.entry;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(AppChrome/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroImageOnly, {
                    image: teamPage.mainImage[0]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSegmentBackground/* default */.Z, {
                    color: "grey100",
                    segmentType: "custom",
                    hasSectionTitle: true,
                    anchorId: "page-title",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.ZP, {
                            $top: 12,
                            $bottom: 12,
                            $between: 10,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSegmentHeading/* default */.Z, {
                                    title: teamPage.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(People, {
                                    people: teamPage.people
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
}
var __N_SSP = true;
/* harmony default export */ var team = (BrixelTeamPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,756,274,783,135,888,179], function() { return __webpack_exec__(4705); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);